<template>
  <el-dialog
    custom-class="import-dialog"
    title="添加直播间"
    :visible="visible"
    width="800px"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="搜索直播间"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search">查询</el-button>
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          ref="brandTable"
          @current-change="handleCurrentChange"
          highlight-current-row
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
          <el-table-column header-align="center" align="center" prop="roomName" label="直播标题"></el-table-column>
          <el-table-column header-align="center" align="center" prop="anchorName" label="主播昵称"></el-table-column>
          <el-table-column header-align="center" align="center" prop="shareImg" label="直播间封面">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                class="mr10"
                :src="scope.row.shareImg"
                :preview-src-list="[scope.row.shareImg]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="liveStatus" label="直播状态">
            <template slot-scope="scope">
              <span class="status playing" v-if="scope.row.liveStatus === 101">直播中</span>
              <span class="status not-start" v-if="scope.row.liveStatus === 102">即将开始</span>
              <span class="status end" v-if="scope.row.liveStatus === 103">已结束</span>
              <span class="status end" v-if="scope.row.liveStatus === 104">禁播</span>
              <span class="status end" v-if="scope.row.liveStatus === 105">暂停中</span>
              <span class="status end" v-if="scope.row.liveStatus === 106">异常</span>
              <span class="status end" v-if="scope.row.liveStatus === 107">已过期</span>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="startTime" label="开播时间"></el-table-column>
          <el-table-column header-align="center" align="center" prop="endTime" label="结束直播"></el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
  },
  components: {},
  data() {
    return {
      sort: {},
      keyWords: "",
      currentRow: {},
      tHeader: [],
      tBody: [],
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      startDate: "",
      endDate: "",
      timeStatus: "",
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    save() {     
      if (!this.checkedRow.length) {
        this.$message({
          type: "warning",
          message: "请先选择直播间"
        });
      } else {
        this.$emit("saveLive", this.checkedRow);
      }
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryLiveList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      });
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleCurrentChange(row) {
      console.log("row:",row);
      this.checkedRow = [row];
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
